export default __webpack_public_path__ + "static/media/char_head_prem_012.9afaf1b5.png";